/**
 * 试题试卷
 */
import request from "@/utils/request";
// import store from '@/store'
import { postForm } from "@/utils/form";

/*
获取医学职业资格分类
*/
export const GetClassLit = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetClassList",
        params
    });
};

/*
获取机构分类
*/
export const GetOrganClassLit = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetOrganMedicalAllClass",
        params
    });
};

/*
获取试题信息
*/
export const GetQuestionInfo = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetMedicalQueation",
        params
    });
};

/*
获取公共题库信息
*/
export const GetPulicQuestionInfo = (params) => {
    return request({
        method: "POST",
        url: "/Api/Question/GetQuesionInfo",
        data: params
    });
};

/*
获取公共题库信息
*/
export const GetPulicQuestionList = (params) => {
    return request({
        method: "POST",
        url: "/Api/Question/GetQuesionInfoList",
        data: params
    });
};

/*
获取错题信息
*/
export const GetQuestionRecord = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/ErrSubList",
        params
    });
};

/*
获取高频考题
*/
export const GetHightQuestion = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/HighSubList",
        params
    });
};

/*
获取做卷记录
*/
export const GetPaperRecord = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/TestRecord",
        params
    });
};

/*
获取试卷信息
*/
export const GetPaperInfo = (params) => {
    return request({
        method: "POST",
        url: "/Api/Paper/GetMedicalPaper",
        params
    });
};

/*
获取精品试卷信息
*/
export const GetBestPaperInfo = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetNewestPaper",
        params
    });
};

/*
获取收藏试卷信息
*/
export const GetCollectPaper = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/CollPaperList",
        params
    });
};

/*
获取收藏试题信息
*/
export const GetCollectQuestion = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/CollSubList",
        params
    });
};

/*
删除做题（错题）记录
*/
export const DelQuestionRecord = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/DelErr",
        params
    });
};

// 删除做卷记录
export const DelTestRecord = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/DelTestRecord",
        params
    });
};

/*
删除收藏（试题、试卷）记录
*/
export const DelCollectRecord = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/CancelCollect",
        params
    });
};

/*
获取科室试题
*/
export const GetDepartmentQuestion = (params, signal) => {
    return request({
        method: "POST",
        url: "/Api/Question/GetDepartmentQuestion",
        params,
        signal
    });
};

/*
公共题库导入批量机构题库
*/
export const ImportPulicQuestionToOrgan = (params) => {
    return request({
        method: "POST",
        url: "/Website/ExamSubject/ImportPulicQuestionToOrgan",
        params
    });
};

// export async function GetDepartmentQuestion(params) {
//   return postForm("/Api/Question/GetDepartmentQuestion", params)
// }
